import PublicationText from 'hb-react/shared/components/Publication/PublicationText';

const ArticleText = ({ text }) => <PublicationText text={text} />;

export default ArticleText;
